module.exports = __webpack_public_path__ + "static/EnmTX_BosDeathTiger_L_B_cl-e958387365191a5e7e5fc49f78d7aad6.gif";